module.exports = __webpack_public_path__ + "img/stt_dalam_proses.17f82151.svg";